import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import APAccordion from "../../../components/APAccordion";
import APDetailRow from "../../../components/APDetailRow";
import APTabs from "../../../components/APTabs";
import { standardVehicleValueFormatter } from "../../../helpers/vehicle";
import {
  APVehicleVariant,
  APVehicleVariantLabelMap,
} from "../../../types/Vehicles";

export type VehicleDetailTab = {
  label: string;
  fields: (keyof APVehicleVariant)[];
};

const APVehicleDetailTabs = ({
  variant,
  vehicleDetailTabs,
  defaultExpanded = false,
  forceOpen = false,
  forceClose = false,
  priceToBeConfirmed = false,
}: {
  variant: APVehicleVariant;
  vehicleDetailTabs: VehicleDetailTab[];
  defaultExpanded?: boolean;
  forceOpen?: boolean;
  forceClose?: boolean;
  priceToBeConfirmed?: boolean;
}) => {
  let allFields: JSX.Element[] = [];

  const tabs = vehicleDetailTabs.map((tab) => {
    const renderedFields = tab.fields.map((field: keyof APVehicleVariant) =>
      priceToBeConfirmed && field === "listPriceIncGst" ? null : (
        <APDetailRow
          key={field}
          label={APVehicleVariantLabelMap[field]}
          value={standardVehicleValueFormatter(field, variant[field])}
        />
      )
    );
    allFields = [
      ...allFields,
      <Box key={`all-${tab.label}`}>{renderedFields}</Box>,
    ];

    return {
      label: tab.label,
      children: <Box key={tab.label}>{renderedFields}</Box>,
    };
  });
  tabs.push({
    label: "All",
    children: (
      <Stack spacing={2} key="all">
        {allFields}
      </Stack>
    ),
  });

  return (
    <APAccordion
      title={"Vehicle Details"}
      defaultExpanded={defaultExpanded}
      forceOpen={forceOpen}
      forceClose={forceClose}
    >
      <Box sx={{ my: 2 }}>
        <APTabs tabs={tabs} />
      </Box>
    </APAccordion>
  );
};

export default APVehicleDetailTabs;
